export default {"src":"/_next/static/media/budget.1dc4ee0f.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};